var map = {
	"./lesson_2_04_audio1.mp3": 1399,
	"./lesson_2_04_audio2.mp3": 1400,
	"./lesson_2_04_audio3.mp3": 1401,
	"./lesson_2_04_audio4.mp3": 1402,
	"./lesson_2_05_audio1.mp3": 1403,
	"./lesson_2_05_audio2.mp3": 1404,
	"./lesson_2_06_audio1.mp3": 1405,
	"./lesson_2_06_audio2.mp3": 1406,
	"./lesson_2_06_audio3.mp3": 1407,
	"./lesson_2_09_audio1.mp3": 1408,
	"./lesson_2_09_audio2.mp3": 1409,
	"./lesson_2_11_audio1.mp3": 1410,
	"./lesson_2_11_audio2.mp3": 1411
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1398;